import React from 'react';

/**
 * Barra de progreso (avance de la sincronización SAT, uso del plan…).
 *
 * @param {number} value  0-100
 * @param {string} color  color del relleno; por defecto el degradado de marca.
 *                        Se usa cuando el valor cambia de significado según el
 *                        umbral (p. ej. el uso del plan: normal / advertencia /
 *                        alerta).
 */
export const Progress = ({ value = 0, label, color, className = '', style }) => {
  const pct = Math.max(0, Math.min(100, Number(value) || 0));
  return (
    <div
      className={['a2-progress', className].filter(Boolean).join(' ')}
      style={style}
      role="progressbar"
      aria-valuenow={Math.round(pct)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={label}
    >
      <div
        className="a2-progress-fill"
        style={{ width: `${pct}%`, ...(color ? { background: color } : null) }}
      />
    </div>
  );
};

/** Spinner circular. */
export const Spinner = ({ size = 18, className = '', style }) => (
  <span
    className={['a2-spinner', className].filter(Boolean).join(' ')}
    style={{ width: size, height: size, ...style }}
    role="status"
    aria-label="Cargando"
  />
);

export default Progress;
